"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputText = exports.validateUrl = exports.validateEmail = exports.createInputTextPassword = exports.createInputTextEmail = exports.createInputNumber = exports.createInputTextArea = exports.createInputText = exports.InputTextComponent = exports.InputTextDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var field_container_1 = require("../elements/field-container");
var validator_1 = __importDefault(require("validator"));
var form_field_id_1 = require("../../utils/form-field-id");
var to_number_1 = require("../../utils/to-number");
var use_focus_ref_1 = require("../../hooks/use-focus-ref");
var memo = React.memo;
var HTML_INPUT_TYPES = {
  float: 'number'
};
exports.InputTextDefaultProps = {
  type: 'text',
  autoComplete: 'off',
  variant: 'border'
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var InputStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n    border: 1px solid ", ";\n    font-weight: 400;\n    font-family: ", ";\n    font-size: ", ";\n    padding: ", " ", " ", ";\n    color: ", ";\n    transition: border-color 0.25s;\n    border-radius: 0;\n    -webkit-appearance: none;\n    \n    ", "\n\n    &:disabled {\n      background-color: #F7F7F7;\n    }\n\n    &[type=number]::-webkit-inner-spin-button, \n    &[type=number]::-webkit-outer-spin-button { \n    -webkit-appearance: none; \n      margin: 0; \n    }\n\n    &:focus {\n      outline: none;\n      border-color: ", "; \n    }\n\n    &::placeholder {\n      color: ", ";\n    }\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n  "], ["\n    display: flex;\n    border: 1px solid ", ";\n    font-weight: 400;\n    font-family: ", ";\n    font-size: ", ";\n    padding: ", " ", " ", ";\n    color: ", ";\n    transition: border-color 0.25s;\n    border-radius: 0;\n    -webkit-appearance: none;\n    \n    ", "\n\n    &:disabled {\n      background-color: #F7F7F7;\n    }\n\n    &[type=number]::-webkit-inner-spin-button, \n    &[type=number]::-webkit-outer-spin-button { \n    -webkit-appearance: none; \n      margin: 0; \n    }\n\n    &:focus {\n      outline: none;\n      border-color: ", "; \n    }\n\n    &::placeholder {\n      color: ", ";\n    }\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n  "])), theme_1.theme.COLOR('line-mid'), theme_1.theme.FONT('sans'), theme_1.theme.FONT_SIZE(16), theme_1.theme.UNIT(3.5), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3.6), theme_1.theme.COLOR('bold'), function (_a) {
    var monospace = _a.monospace;
    return monospace && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      font-family: ", ";\n    "], ["\n      font-family: ", ";\n    "])), theme_1.theme.FONT('mono'));
  }, theme_1.theme.COLOR('primary'), theme_1.theme.COLOR('text-very-subtle'), function (props) {
    return !props.valid && (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      color: ", ";\n      border-color: ", ";\n      &::placeholder {\n        color: ", ";\n      }\n    "], ["\n      color: ", ";\n      border-color: ", ";\n      &::placeholder {\n        color: ", ";\n      }\n    "])), theme_1.theme.COLOR('error'), theme_1.theme.COLOR('error'), theme_1.theme.COLOR('error'));
  }, function (props) {
    return props.variant === 'gradient' && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      background: linear-gradient(to bottom, #f3f3f3 0%,rgba(255, 255, 255, 0.0) 95%);\n      border: none;\n      font-size: ", ";\n      padding: ", " ", " ", ";\n      border: 2px solid ", ";\n\n      &:focus {\n        border-color: ", ";\n        border-top-color: ", ";\n      }\n    "], ["\n      background: linear-gradient(to bottom, #f3f3f3 0%,rgba(255, 255, 255, 0.0) 95%);\n      border: none;\n      font-size: ", ";\n      padding: ", " ", " ", ";\n      border: 2px solid ", ";\n\n      &:focus {\n        border-color: ", ";\n        border-top-color: ", ";\n      }\n    "])), theme_1.theme.FONT_SIZE(16), theme_1.theme.UNIT(3), theme_1.theme.UNIT(4), theme_1.theme.UNIT(3.5), theme_1.theme.COLOR('line-subtle'), theme_1.theme.COLOR('line-subtle'), theme_1.theme.COLOR('primary'));
  }, function (props) {
    return props._maxWidth && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      max-width: ", ";\n    "], ["\n      max-width: ", ";\n    "])), props._maxWidth);
  }, function (props) {
    return props.variant === 'gradient' && !props.valid && (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      border-color: ", ";\n      border-top-color: ", ";\n    "], ["\n      border-color: ", ";\n      border-top-color: ", ";\n    "])), theme_1.theme.COLOR('line-mid'), theme_1.theme.COLOR('error'));
  })
});
var TextAreaStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", "\n    resize: vertical;\n    line-height: 1.5em;\n    ", "\n\n  "], ["\n    ", "\n    resize: vertical;\n    line-height: 1.5em;\n    ", "\n\n  "])), InputStyles, function (props) {
    return props._height && props._height && (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      height: ", ";\n    "], ["\n      height: ", ";\n    "])), props._height);
  })
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(field_container_1.FieldContainer)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Input: styled_components_1.default.input(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), InputStyles),
  TextArea: styled_components_1.default.textarea(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), TextAreaStyles)
};
var InputTextComponent = function (props) {
  var className = props.className,
    field = props.field,
    autoComplete = props.autoComplete,
    onChange = props.onChange,
    onBlur = props.onBlur;
  var type = HTML_INPUT_TYPES[props.type] || props.type;
  if (!field) {
    throw new Error('InputText requires a field specification.');
  }
  var placeholder = field.placeholder,
    height = field.height,
    name = field.name,
    valid = field.valid,
    value = field.value,
    focus = field.focus;
  var handleChange = function (event) {
    var target = event.target;
    var fieldValue = target && target.value;
    var value = type === 'number' ? (0, to_number_1.toNumber)(fieldValue) : fieldValue;
    onChange({
      name: name,
      value: value
    });
  };
  var handleBlur = function (event) {
    var target = event.target;
    if (onBlur) {
      onBlur({
        name: name,
        value: target && target.value
      });
    }
  };
  var input = (0, use_focus_ref_1.useFocusRef)(focus);
  var stepProps = props.type === 'float' ? {
    step: '0.00001'
  } : {};
  return React.createElement(My.Container, {
    field: field,
    className: className
  }, type === 'textarea' ? React.createElement(My.TextArea, {
    monospace: field.monospace,
    id: (0, form_field_id_1.formFieldId)(field),
    ref: input,
    _height: field.height || '140px',
    _maxWidth: field.maxWidth,
    value: value,
    valid: valid,
    disabled: field.disabled,
    autoComplete: autoComplete,
    onChange: handleChange,
    onBlur: handleBlur,
    name: name,
    height: height,
    placeholder: placeholder
  }) : React.createElement(My.Input, __assign({}, stepProps, {
    id: (0, form_field_id_1.formFieldId)(field),
    monospace: field.monospace,
    ref: input,
    value: value,
    _maxWidth: field.maxWidth,
    valid: valid,
    maxLength: field.maxLength,
    disabled: field.disabled,
    autoComplete: autoComplete,
    onChange: handleChange,
    onBlur: handleBlur,
    name: name,
    placeholder: placeholder,
    type: type
  })));
};
exports.InputTextComponent = InputTextComponent;
var createInputText = function (props) {
  return React.createElement(exports.InputText, __assign({}, props));
};
exports.createInputText = createInputText;
var createInputTextArea = function (props) {
  return React.createElement(exports.InputText, __assign({}, props, {
    type: "textarea"
  }));
};
exports.createInputTextArea = createInputTextArea;
var createInputNumber = function (props) {
  return React.createElement(exports.InputText, __assign({}, props, {
    type: "number"
  }));
};
exports.createInputNumber = createInputNumber;
var createInputTextEmail = function (props) {
  return React.createElement(exports.InputText, __assign({}, props, {
    type: "email"
  }));
};
exports.createInputTextEmail = createInputTextEmail;
var createInputTextPassword = function (props) {
  return React.createElement(exports.InputText, __assign({}, props, {
    type: "password"
  }));
};
exports.createInputTextPassword = createInputTextPassword;
var validateEmail = function (_a) {
  var field = _a.field;
  return !field.value || validator_1.default.isEmail(field.value);
};
exports.validateEmail = validateEmail;
var validateUrl = function (_a) {
  var field = _a.field;
  return !field.value || validator_1.default.isURL(field.value, {
    require_tld: false,
    require_host: false
  });
};
exports.validateUrl = validateUrl;
exports.InputTextComponent.defaultProps = exports.InputTextDefaultProps;
exports.InputText = memo(exports.InputTextComponent);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;